<template>
    <div>
        <messageTitle :avatar="message.avatar"
            :nick="nick"
            :isMine="isMine"
            :avatarType="avatar"
            :circular="isCustom"
            :showNick="!(isCustom && isMine)"
            :showAvatar="!(!isCustom && isMine)"
            :size="isCustom ? 'middle' : 'small'">
            <template v-if="isMine && !isCustom && message.isRead">
                <img src="@/assets/instantMessaging/ic_read.svg" class="chat-message_receive_icon"/>
            </template>
            <messageBubble
                :isMine="isMine"
                :type="isCustom ? 1 : 2">
                <template v-for="(item, index) in contentList">
                    <!--<span class="text-box" :key="index" v-if="item.name === 'text'">{{ item.text }}</span>-->
                    <template v-if="item.name === 'text'">
                        <span v-for="text in item.text">{{text}}</span>
                    </template>
                    <img v-else-if="item.name === 'img'" :src="require('../../../../assets/instantMessaging' + item.src)" class="message-icon" :key="index"/>
                </template>
            </messageBubble>
        </messageTitle>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { decodeText, messageSenderRole, messageIsCustom } from '../../utils';
import messageTitle from '../messageTitle';
import messageBubble from '../messageBubble';
export default {
    name: "textElement",
    components: {
	    messageTitle,
	    messageBubble
    },
    props: {
        payload: {
            type: Object,
            required: true
        },
        message: {
            type: Object,
            required: true
        }
    },
    data() {
        return {}
    },
    computed: {
	    ...mapGetters('instantMessaging', ['isCustom', 'isC2C']),
        ...mapState('instantMessaging', ['currentMemberList']),
        isMine() {
            return this.message.flow === 'out'
        },
        contentList() {
            return decodeText(this.payload)
        },
        nick() {
            return `${this.message.nick || `暂无昵称（${this.message.from}）`}`;

            if (this.isC2C) {
                return `${this.message.nick || `暂无昵称（${this.message.from}）`}`;
            } else {
	            return `${this.message.nick}(${messageSenderRole(this.message, this.currentMemberList)})`
            }
        },
        avatar() {
            if (messageIsCustom(this.message, this.currentMemberList)) {
                return 'custom';
            } else {
                return 'staff';
            }
        }
    },
    watch: {},
    mounted() {

    },
    methods: {}
}
</script>

<style scoped lang="less">
.chat-message_receive_icon {
    display: block;
    width: 12px;
    height: 12px;
    margin-right: 4px;
}
.message-icon {
    width: 16px;
    height: 16px;
}
</style>
